import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { ReactComponent as ListIcon } from "./../../images/svg/list.svg";
import { ReactComponent as MapIcon } from "./../../images/svg/map.svg";
import { gettext } from "../../adapter";

const ViewSwitch = ({ view }) => {
  const history = useHistory();
  const { search } = useLocation();
  const setView = (view) => {
    const parsed = queryString.parse(search);
    parsed.view = view;
    history.push("?" + queryString.stringify(parsed));
  };
  return (
    <div className="viewswitch">
      <span
        onClick={() => {
          setView("list");
        }}
        className={view === "list" ? "is-selected" : ""}
      >
        <ListIcon className="icon is-inline" />
        {gettext("List")}
      </span>
      <span
        onClick={() => {
          setView("map");
        }}
        className={view === "map" ? "is-selected" : ""}
      >
        <MapIcon className="icon is-inline" />
        {gettext("Map")}
      </span>
    </div>
  );
};

export default ViewSwitch;
